import { Button, ChipButton, Plus } from 'component-library';
import { useTranslation } from 'react-i18next';
import type { ContainerTemplate } from '@sr/types';
import { templateKey } from './templateSelection';
import { TemplateControls, TemplateCreateButton } from './styles';

export const ContainerTemplateMenu = ({
  templates,
  selected,
  selectedKey,
  disabled,
  hasContainers,
  onSelect,
  onDelete,
  onCreate,
  onUpdate,
}: {
  templates: ContainerTemplate[];
  selected: ContainerTemplate | undefined;
  selectedKey: string | undefined;
  disabled: boolean;
  hasContainers: boolean;
  onSelect: (key: string | undefined) => void;
  onDelete: (key: string) => void;
  onCreate: () => void;
  onUpdate: (record: ContainerTemplate) => Promise<void>;
}) => {
  const { t } = useTranslation();

  return (
    <TemplateControls>
      <ChipButton
        label={t('container-templates.menu.label')}
        items={
          disabled
            ? []
            : templates.map((record) => ({ label: record.data.name, value: templateKey(record) }))
        }
        selectedValues={selectedKey ? [selectedKey] : []}
        singleSelect
        menuVariant="actions"
        onDeleteItem={onDelete}
        deleteItemAriaLabel={(item) => `${t('container-templates.delete.button')}: ${item.label}`}
        onChange={(values) => {
          onSelect(values[0]);
        }}
      >
        <TemplateCreateButton
          type="button"
          hasTemplates={!disabled && templates.length > 0}
          disabled={disabled}
          onClick={onCreate}
        >
          {t('container-templates.create.button')}
          <Plus />
        </TemplateCreateButton>
      </ChipButton>
      {selected && (
        <Button
          variant="text-primary"
          disabled={disabled || !hasContainers}
          onClick={() => onUpdate(selected)}
        >
          {t('container-templates.update.button')} “{selected.data.name}”
        </Button>
      )}
    </TemplateControls>
  );
};
